import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { HiringRegimeTypeEnum } from '../../models/job-opportunity-application.model';

@Injectable({
  providedIn: 'root',
})
export class JobApplicationFormatService {
  constructor(private translateService: TranslateService) {}

  async formatWorkModel(
    isLocal: boolean,
    isHybrid: boolean,
    isHomeOffice: boolean,
    separator: string = ' | ',
  ): Promise<string> {
    const translations = await lastValueFrom(
      this.translateService.get(['l-presential', 'l-hybrid', 'l-remote']),
    );

    return [
      isLocal ? translations['l-presential'] : '',
      isHybrid ? translations['l-hybrid'] : '',
      isHomeOffice ? translations['l-remote'] : '',
    ]
      .filter((f) => f !== '')
      .join(separator);
  }

  async formatHiringRegime(
    hiringRegimeTypes?: HiringRegimeTypeEnum[],
    separator: string = ' - ',
  ): Promise<string> {
    const translations = await lastValueFrom(
      this.translateService.get([
        'l-internship',
        'l-freelancer',
        'l-cooperated',
        'l-self-employed',
        'l-apprentice',
        'l-scholarship-holder',
        'l-temp',
        'l-volunteer',
      ]),
    );

    return [
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.CLT) ? 'CLT' : '',
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.PJ) ? 'PJ' : '',
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.Internship)
        ? translations['l-internship']
        : '',
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.Freelancer)
        ? translations['l-freelancer']
        : '',
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.Cooperated)
        ? translations['l-cooperated']
        : '',
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.SelfEmployed)
        ? translations['l-self-employed']
        : '',
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.Apprentice)
        ? translations['l-apprentice']
        : '',
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.ScholarshipHolder)
        ? translations['l-scholarship-holder']
        : '',
      hiringRegimeTypes?.includes(HiringRegimeTypeEnum.Volunteer)
        ? translations['l-volunteer']
        : '',
    ]
      .filter((f) => f !== '')
      .join(separator);
  }
}
